/* skipped.icon.svg.js */

module.exports = {
    icon: `    
        <svg viewBox="0 0 19.8 19.8" preserveAspectRatio="none">
            <path class="a" d="M10.31.36a9.91,9.91,0,1,0,9.9,9.91A9.92,9.92,0,0,0,10.31.36Zm0,1.39a8.5,8.5,0,0,1,5.61,2.11L3.84,15.79a8.5,8.5,0,0,1,6.47-14Zm0,17A8.51,8.51,0,0,1,5,17l12-11.87a8.51,8.51,0,0,1-6.75,13.71Z" transform="translate(-0.41 -0.36)"/>
        </svg>
     `
};
